module.exports = __webpack_public_path__ + "static/fonts/DejaVuSansMono.f7435b1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/fonts/DejaVu/DejaVuSansMono.ttf?v=1.1
// module id = 1641
// module chunks = 28